import {Pipe, PipeTransform} from '@angular/core';
import {getDate} from 'date-fns';

@Pipe({
  name: 'compareDates'
})
export class CompareDatesPipe implements PipeTransform {

  transform(value: Date | string, otherDate: Date | string, operator: '<' | '>' | '===' | '!=='): boolean {
    value = typeof value === 'string' ? new Date(value) : value;
    otherDate = typeof otherDate === 'string' ? new Date(otherDate) : otherDate;
    if (operator === '<') {
      return getDate(value) < getDate(otherDate);
    } else if (operator === '>') {
      return getDate(value) > getDate(otherDate);
    } else if (operator === '===') {
      return getDate(value) === getDate(otherDate);
    } else if (operator === '!==') {
      return getDate(value) !== getDate(otherDate);
    }
  }

}
